<template>
    <div style="position: absolute; top: 9%;">
      <Header />
      <div class="content-positining text" style="padding-left: 0;">
        <div class="user__headers">
          Contact Us
        </div>
          <br>
          <div style="margin-bottom: 2%;">Thank you for contacting us. <br/> One of our team’s representatives will be in touch with you soon.</div>
          <br>
      </div>
    </div>
</template>

<script>
export default {
  name: 'ContactView'
}
</script>
